// import {
//   getReq,
//   END_POINTS
// } from '@/api'
// import { routerCommon } from '@/router/router'
// import routerMap from '@/router/routerMap'

const state = {
  homePage: '/subsys_page',
  // homePageMenuKey: '',
  hasGetRules: false,
  activePath: '',
  resourceList: []
}

// const getAccesRouterList = (routerMap, rules) => {
//   let newRouter = []
//   routerMap.forEach(map => {
//     rules.forEach(rule => {
//       if (map.name === rule.menuKey) {
//         map['path'] = rule.url
//         map.meta.title = rule.name
//         newRouter.push(map)
//       }
//     })
//   })
//   return newRouter
// }

const actions = {
  // async getResourceListByRoleName({
  //   commit
  // }) {
  //   // const token = localStorage.getItem('token')
  //   const resourceListObject = await getReq(END_POINTS.GET_RESOURCE_LIST_BY_ROLE_NAME, {})
  //   // 将匹配到的路由拼接到子路由中，返回所有匹配到的路由
  //   const routerList = getAccesRouterList(routerMap, resourceListObject.data.twoLevelResourceList)
  //   const routerCommonChild = routerCommon.children.concat(routerList)
  //   routerCommon.children = routerCommonChild
  //   if (resourceListObject.success) {
  //     // 生成菜单
  //     commit('updateResourceList', {serverMenu: resourceListObject.data, routerCommonChild})
  //   }
  //   return routerCommon
  // }
}

const mutations = {
  // updateHomePage(state, homePage) {
  //   state.homePage = homePage
  // },
  updateHasRule(state, hasRule) {
    state.hasGetRules = hasRule
  },
  updateActivePath(state, url) {
    state.activePath = url
  }
  // updateResourceList(state, {serverMenu, routerCommonChild}) {
  //   // 已经获取到权限菜单
  //   state.hasGetRules = true
  //   let oneLevelResourceList = serverMenu.oneLevelResourceList
  //   // 服务端返回大量不存在的二级页面，需要过滤
  //   let twoLevelResourceList = serverMenu.twoLevelResourceList.filter(menu => {
  //     return routerCommonChild.find(router => router.name === menu.menuKey)
  //   })
  //   // 循环一二级菜单，构造侧边栏菜单树的结构
  //   let newOneLevelResource = []
  //   oneLevelResourceList.forEach(value => {
  //     if (value.menuKey) {
  //       let children = []
  //       twoLevelResourceList.forEach(valueTwo => {
  //         const path = routerCommonChild.find(router => router.name === valueTwo.menuKey).path
  //         if (valueTwo.parentId === value.id) {
  //           children.push({
  //             id: valueTwo.id,
  //             name: valueTwo.name,
  //             url: path,
  //             menuKey: valueTwo.menuKey
  //           })
  //         }
  //       })
  //       value['children'] = children
  //       newOneLevelResource.push(value)
  //     }
  //   })
  //   // for (var n = 0, hasFoundMenu = false; n < newOneLevelResource.length; n++) {
  //   //   if (newOneLevelResource[n].children && newOneLevelResource[n].children.length > 0) {
  //   //     for (var m = 0; m < newOneLevelResource[n].children.length; m++) {
  //   //       state.homePageMenuKey = newOneLevelResource[n].children[m].menuKey
  //   //       state.homePage = newOneLevelResource[n].children[m].url
  //   //       hasFoundMenu = true
  //   //       break
  //   //     }
  //   //   }
  //   //   if (hasFoundMenu) {
  //   //     break
  //   //   }
  //   // }
  //
  //   newOneLevelResource = newOneLevelResource.filter(item => item.children && item.children.length > 0)
  //   state.resourceList = newOneLevelResource
  // }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/permission/index.js